'use client';

import { useEffect } from 'react';
import { datadogRum, type RumInitConfiguration } from '@datadog/browser-rum';
import { DATADOG_APM_TRACING_URLS } from 'src/config';

export interface DatadogConfig {
  DATADOG_APPLICATION_ID?: string;
  DATADOG_CLIENT_TOKEN?: string;
  DATADOG_SITE?: string;
  DATADOG_SERVICE?: string;
  DATADOG_ENV?: string;
  DATADOG_APP_VERSION?: string;
  DATADOG_ALLOWED_TRACING_URLS?: (string | RegExp)[];
  DATADOG_SESSION_SAMPLE_RATE?: number;
  DATADOG_SESSION_REPLAY_SAMPLE_RATE?: number;
}

interface DatadogInitProps {
  config: DatadogConfig;
}

export default function DatadogInit({ config }: DatadogInitProps) {
  useEffect(() => {
    // Prevent re-initialization if already initialized (e.g., on route changes)
    if (datadogRum.getInitConfiguration()) return;

    if (
      config.DATADOG_APPLICATION_ID
      && config.DATADOG_CLIENT_TOKEN
      && config.DATADOG_SITE
      && config.DATADOG_SERVICE
      && config.DATADOG_ENV
      && typeof config.DATADOG_SESSION_SAMPLE_RATE === 'number'
      && typeof config.DATADOG_SESSION_REPLAY_SAMPLE_RATE === 'number'
    ) {
      datadogRum.init({
        applicationId: config.DATADOG_APPLICATION_ID,
        clientToken: config.DATADOG_CLIENT_TOKEN,
        site: config.DATADOG_SITE as RumInitConfiguration['site'],
        service: config.DATADOG_SERVICE,
        env: config.DATADOG_ENV,
        version: config.DATADOG_APP_VERSION,
        allowedTracingUrls: DATADOG_APM_TRACING_URLS,
        sessionSampleRate: config.DATADOG_SESSION_SAMPLE_RATE,
        sessionReplaySampleRate: config.DATADOG_SESSION_REPLAY_SAMPLE_RATE,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'allow',
      });
      datadogRum.setGlobalContextProperty('user_business', 'connect');
      datadogRum.setGlobalContextProperty('user_env', config.DATADOG_ENV);
    }
  }, [config]);

  return null;
}
